var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: _vm.PERMISSIONS.VIEW_PORTFOLIO,
          expression: "PERMISSIONS.VIEW_PORTFOLIO",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c("portfolio-widget-row", { attrs: { fetch: true } }),
      _c(
        "div",
        {
          staticClass: "bs-table-custom-toolbar",
          attrs: { id: "licensesToolbar" },
        },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.licenseAddLicenseModal",
                  modifiers: { licenseAddLicenseModal: true },
                },
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: _vm.PERMISSIONS.SYSTEM_CONFIGURATION,
                  expression: "PERMISSIONS.SYSTEM_CONFIGURATION",
                },
              ],
              attrs: { size: "md", variant: "outline-primary" },
            },
            [
              _c("span", { staticClass: "fa fa-plus" }),
              _vm._v(" " + _vm._s(_vm.$t("message.add_license")) + "\n    "),
            ]
          ),
        ],
        1
      ),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: { "on-load-success": _vm.onLoadSuccess },
      }),
      _c("license-add-license-modal", {
        on: { refreshTable: _vm.refreshTable },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }